<template>
  <div class="cstm_graph_holder">
    <div class="cstm_card_header cstm_dashboard_card px-4 py-2">
      <h4 style="font-weight: 500;">{{ graph.name }}</h4>
      <vs-dropdown v-if="!preview">
        <vs-button class="btn-drop" type="flat" icon="more_vert"></vs-button>
        <vs-dropdown-menu>
          <vs-dropdown-item @click="beginEdit()">
            Edit
          </vs-dropdown-item>
          <vs-dropdown-item @click="openConfirm()">
            Delete
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <vx-card class="dynamic_stat_card">
        
        <div v-if="!preview" class="flex flex-wrap w-full my-4">
          <label class="vs-input--label pl-0">Date Range: </label>
          <date-range-picker
            class="w-full"
            ref="picker"
            :locale-data="{ firstDay: 1, format: 'YYYY-MM-DD' }"
            :showWeekNumbers="true"
            :showDropdowns="true"
            :autoApply="true"
            :ranges="customDateRanges()"
            v-model="dateRange"
            @update="generateNewGraph()"
          >
            <template v-slot:input="picker" style="min-width: 350px">
              <b>{{ picker.startDate | moment('DD-MM-YYYY') }}</b> to <b>{{ picker.endDate | moment('DD-MM-YYYY') }}</b>
            </template>
          </date-range-picker>
        </div>
      
      <bar-chart v-if="graph.graph_type === 'column'" :graph="graph" :graphData="graphData" />
      <bar-chart v-if="graph.graph_type === 'bar'" :graph="graph" :graphData="graphData" :horizontal="true" />
      <line-chart v-if="graph.graph_type === 'line'" :graph="graph" :graphData="graphData" />
      <pie-chart v-if="graph.graph_type === 'pie'" :graph="graph" :graphData="graphData" />
      <radar-chart v-if="graph.graph_type === 'radar'" :graph="graph" :graphData="graphData" />

    </vx-card>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'
import barChart from './charts/barChart.vue'
import pieChart from './charts/pieChart.vue'
import lineChart from './charts/lineChart.vue'
import radarChart from './charts/radarChart.vue'

export default {
  name: 'Graph-Card',
  components: {
    DateRangePicker,
    barChart,
    pieChart,
    lineChart,
    radarChart
  },
  props: ['cardId', 'graph', 'graphData', 'preview'],
  data () {
    return {
      dateRange: { startDate: this.graph.additional_data.start_date, endDate: this.graph.additional_data.end_date },
      activeConfirm: false
    }
  },
  methods: {
    async generateNewGraph () {
      const payload = {
        additional_data: {
          start_date: moment(this.dateRange.startDate).format('YYYY-MM-DD'),
          end_date: moment(this.dateRange.endDate).format('YYYY-MM-DD')
        },
        platform_module_id: this.graph.platform_module_id,
        x_axis: this.graph.x_axis,
        y_axis: this.graph.y_axis
      }

      this.$emit('filter-result', { card_id: this.cardId, payload })
    },
    openConfirm () {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Delete Card',
        text: 'Are you sure you want to delete this card?',
        accept: this.onDelete
      })
    },
    onDelete () {
      this.$emit('card-delete', this.cardId)
    },
    beginEdit () {
      this.$emit('card-edit', { card_id: this.cardId, widget_type: 'graph', data: this.graph })
    }
  }
}
</script>
